import React from 'react'
import { Box, Typography } from '@mui/material'
import {
  CampaignResponse,
  DeliveryType,
  PreviewResponse
} from '../../types/campaign'
import {
  getTotalBudget,
  getTargetImpressions,
  getCPM,
  getPlayFrequency
} from '../utils'
import theme from '../theme'
import InfoDisplay from '../InfoDisplay'
import DollarBill from '../icons/DollarBill'
import TimerIcon from '../icons/TimerIcon'
import ImpressionsIcon from '../icons/ImpressionsIcon'
import StoreIcon from '../icons/StoreIcon'
import ScreenIcon from '../icons/ScreenIcon'

interface Props {
  campaign?: CampaignResponse
  previewResponse?: PreviewResponse | null
  selectedStores?: number[] | null
}

const FlightSidebar = ({ campaign, previewResponse, selectedStores }: Props) => {
  if (!campaign) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        color: theme.palette['sage-200'],
        padding: theme.space['32'],
        gap: theme.space['40']
      }}
    >
      <Typography variant="heading-2">{campaign?.name}</Typography>
      <InfoDisplay
        label="Budget"
        color={theme.palette['base-white']}
        value={getTotalBudget(campaign)}
        icon={<DollarBill sx={{ width: '17px', height: '18px' }} />}
      />
      {campaign.delivery_type === DeliveryType.Impressions && (
        <InfoDisplay
          label="Impressions"
          color={theme.palette['base-white']}
          value={getTargetImpressions(campaign)}
          icon={<ImpressionsIcon sx={{ width: '17px', height: '19px' }} />}
        />
      )}
      {campaign.delivery_type === DeliveryType.PlayFrequency && (
        <InfoDisplay
          label="Play Frequency"
          color={theme.palette['base-white']}
          value={getPlayFrequency(campaign)}
          icon={<ImpressionsIcon sx={{ width: '17px', height: '19px' }} />}
        />
      )}
      {campaign.delivery_type === DeliveryType.Impressions && (
        <InfoDisplay
          label="CPM"
          color={theme.palette['base-white']}
          value={getCPM(campaign)}
          icon={<TimerIcon sx={{ width: '17px', height: '18px' }} />}
        />
      )}
      <Box display="flex" flexDirection="column" gap={theme.space['40']}>
        <InfoDisplay
          label="Selected Stores"
          color={theme.palette['base-white']}
          value={selectedStores?.length || '-'}
          icon={<StoreIcon sx={{ width: '17px', height: '18px' }} />}
        />
        <InfoDisplay
          label="Selected Screens"
          color={theme.palette['base-white']}
          value={previewResponse?.screen_count || '-'}
          icon={<ScreenIcon sx={{ width: '17px', height: '22px' }} />}
        />
      </Box>
    </Box>
  )
}

export default FlightSidebar
